import React, { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import Logo from './Logo';
import './creditplate.css';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`cp-nav ${scrolled ? 'cp-nav-solid' : ''}`}>
      <div className="cp-wrap cp-nav-row">
        <Link to="/" className="cp-brand" aria-label="CreditPlate home">
          <Logo />
        </Link>
        <button
          className="cp-burger"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? '✕' : '☰'}
        </button>
        <ul className={`cp-menu ${open ? 'cp-menu-open' : ''}`}>
          <li><NavLink to="/" end>Home</NavLink></li>
          <li><NavLink to="/about-us">About Us</NavLink></li>
          <li><NavLink to="/contact-us">Contact Us</NavLink></li>
          <li><NavLink to="/repay-loan">Repay Loan</NavLink></li>
          <li><NavLink to="/apply-now" className="cp-btn cp-btn-sm">Apply Now</NavLink></li>
        </ul>
      </div>
    </header>
  );
};

export default Navbar;
